/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { logo } from "../../Constant/images";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row newsletter_ptm">
          <div className="col-xl-6 col-lg-6 col-12">
            <div className="newsletter-title">
              <h2>Stay Connected with our newsletter.</h2>
            </div>
          </div>

          <div className="col-xl-6 col-lg-6 col-12">
            <div className="newsletter-form">
              <form action="#" className="subscribe">
                <input
                  type="text"
                  className="subscribe__input"
                  placeholder="example@yourmail.com"
                />
                <button type="button" className="subscribe__btn">
                  Subscribe
                </button>
              </form>
            </div>
          </div>
        </div>

        <div className="row footer_br">
          <div className="col-xl-2 col-lg-2 col-md-12 col-12">
            <div className="footer_logo">
              <a href="index.html">
                <img src={logo} alt="logo" />
              </a>
            </div>
          </div>

          <div className="col-xl-8 col-lg-8 col-md-12 col-12">
            <div className="footer_menu">
              <ul>
                <li>
                  <a href="#home">Home</a>
                </li>
                <li>
                  <a href="#about">About</a>
                </li>
                <li>
                  <a href="#service">Service</a>
                </li>
                <li>
                  <a href="#blog">Blog</a>
                </li>
                <li>
                  <a href="#contact">Contact</a>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-xl-2 col-lg-2 col-md-12 col-12">
            <div className="footer_social">
              <ul>
                <li>
                  <a href="#" className="ti-facebook f_facebook"></a>
                </li>
                <li>
                  <a href="#" className="ti-twitter f_twitter"></a>
                </li>
                <li>
                  <a href="#" className="ti-linkedin f_linkedin"></a>
                </li>
                <li>
                  <a href="#" className="ti-youtube f_youtube"></a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12 text-center wow zoomIn">
            <div className="footer_content">
              <p>Copyright © 2025. All rights Reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
